export default "__VITE_ASSET__B4I$8dDy__"